import type { DeviceType } from '~/types/device';

const useDevice = (): DeviceType => {
  const context = useNuxtApp();

  return context.$device;
};

export default useDevice;
